import React from 'react'
import { useNavigate } from 'react-router-dom'

import type { RoutePath } from '../routes'

interface BackButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  to?: RoutePath
}

export const BackButton: React.FC<BackButtonProps> = ({ to = '/', onClick, ...props }) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e)
    if (!e.defaultPrevented) {
      void navigate(to)
    }
  }

  return (
    <button className="backButton" onClick={handleClick} {...props}>
      Takaisin
    </button>
  )
}
